export default __webpack_public_path__ + "static/media/ppi-horizontal-white.ff218c85.svg";